import { useQuery } from "@tanstack/react-query";
import type { PublicPackageResponse } from "../../publicPackages/publicPackagesApi";
import { listAlternativePackages } from "../../publicPackages/publicPackagesApi";

export function useAlternativePackages(props: { forPackage: PublicPackageResponse; maxItems: number }) {
  const packageId = props.forPackage.id;
  const { data, isLoading } = useQuery({
    queryKey: ["public", "packages", packageId, "alternative"],
    queryFn: ({ signal }) => listAlternativePackages(packageId.id, signal),
  });

  return {
    isLoading,
    packages: (data ?? []).slice(0, props.maxItems),
  };
}
